import React, { useMemo } from "react";
import { ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, ImageSizeTokens, SizeTypeTokens } from "@voltmoney/schema";
import { Typography } from "../../typography/Typography";
import { Icon } from "../../icon/Icon";
import { isMobileView } from "../../stack/utils";
import { Image } from "../../image/Image";
import { Divider } from "../../divider/Divider";
import { Button } from "../../button/Button";
import { Space } from "../../space/Space";
import { isFromAndroidWebview } from "../utils";
const isFromMobileView = isMobileView();
// @ts-ignore
const PreviewCollateral = ({ previewUrl, height, triggerAction, goBackAction, downloadAction, loading, imageNameFromAPI, imageFileExtension, shareOnWhatsAppAction }) => {
    const headerView = () => {
        return (React.createElement(View, { style: styles.headerViewContainer },
            React.createElement(Typography, { label: "Preview collateral", fontSize: FontSizeTokens.LG, fontWeight: "700", lineHeight: 26, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins }),
            React.createElement(TouchableOpacity, { onPress: () => {
                    triggerAction({
                        ...goBackAction
                    });
                } },
                React.createElement(Icon, { name: IconTokens.CrossIcon, size: IconSizeTokens.XXL }))));
    };
    const imagePreview = useMemo(() => {
        return (React.createElement(ScrollView, { style: { paddingBottom: 40 } },
            React.createElement(View, { style: styles.imagePreviewContainer },
                React.createElement(View, { style: {
                        borderWidth: 2,
                        borderColor: '#E4E7EC',
                        borderRadius: 2,
                        width: isFromMobileView ? 330 : 488,
                        height: isFromMobileView ? 328 : 488,
                    } },
                    React.createElement(Image, { size: ImageSizeTokens.FULL, padding: SizeTypeTokens.NONE, uri: previewUrl })))));
    }, [previewUrl]);
    const bottomView = () => {
        return (React.createElement(View, { style: styles.downloadFormBottomContainer },
            React.createElement(Button, { label: "Go back", type: ButtonTypeTokens.LargeSoftFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                    triggerAction({
                        ...goBackAction
                    });
                }, customWidth: 164 }),
            React.createElement(Space, { size: SizeTypeTokens.XL }),
            React.createElement(Button, { label: "Download", type: ButtonTypeTokens.LargeFilled, customWidth: 164, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                    triggerAction({
                        ...downloadAction,
                        payload: {
                            imageUrl: previewUrl,
                            imageNameFromAPI: imageNameFromAPI,
                            imageFileExtension: imageFileExtension,
                            ...downloadAction.payload
                        }
                    });
                }, loading: loading })));
    };
    const bottomViewMobile = () => {
        return isFromAndroidWebview() ? (React.createElement(View, { style: { paddingHorizontal: 16,
                paddingVertical: 12,
                backgroundColor: 'white',
                borderTopWidth: 1,
                borderColor: '#F2F4F7',
                width: '100%',
                position: 'absolute',
                bottom: 0,
                flexDirection: 'row',
                alignContent: 'center',
                justifyContent: 'center',
                marginTop: 16,
                alignSelf: 'center' } },
            React.createElement(View, { style: { flex: 0.5, marginRight: 16, marginTop: 2 } },
                React.createElement(Button, { label: "Share on WhatsApp", type: ButtonTypeTokens.LargeSoftFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                        triggerAction({
                            ...shareOnWhatsAppAction,
                            payload: {
                                imageUrl: previewUrl,
                                imageNameFromAPI: imageNameFromAPI,
                                imageFileExtension: imageFileExtension,
                                ...shareOnWhatsAppAction.payload
                            }
                        });
                    } })),
            React.createElement(View, { style: styles.downloadFormBottomContainerAppView },
                React.createElement(Button, { label: "Download", type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                        triggerAction({
                            ...downloadAction,
                            payload: {
                                imageUrl: previewUrl,
                                imageNameFromAPI: imageNameFromAPI,
                                imageFileExtension: imageFileExtension,
                                ...downloadAction.payload
                            }
                        });
                    } })))) : (React.createElement(View, { style: styles.downloadFormBottomContainerMobile },
            React.createElement(Button, { label: "Download", type: ButtonTypeTokens.LargeFilled, width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, onPress: () => {
                    triggerAction({
                        ...downloadAction,
                        payload: {
                            imageUrl: previewUrl,
                            imageNameFromAPI: imageNameFromAPI,
                            imageFileExtension: imageFileExtension,
                            ...downloadAction.payload
                        }
                    });
                } })));
    };
    const imageMobileView = useMemo(() => {
        return (React.createElement(View, { style: { borderWidth: 2, borderColor: '#E4E7EC' } },
            React.createElement(Image, { size: ImageSizeTokens.Size_330, width: 328, height: 328, padding: SizeTypeTokens.NONE, uri: previewUrl })));
    }, [previewUrl]);
    return (React.createElement(View, { style: [styles.container, { height: height }] },
        headerView(),
        React.createElement(Divider, { size: DividerSizeTokens.SM, color: ColorTokens.Grey_Chalk }),
        isFromMobileView ?
            React.createElement(View, { style: [styles.imageContainerMobile, { height: height - 60 }] },
                imageMobileView,
                bottomViewMobile())
            :
                React.createElement(View, { style: [styles.imageContainer, { height: height - 60 }] },
                    imagePreview,
                    bottomView())));
};
const styles = StyleSheet.create({
    container: {
        width: '100%',
        height: "100%",
    },
    headerViewContainer: {
        height: 60,
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 16
    },
    imagePreviewContainer: {
        width: "100%",
        height: '100%',
        padding: 24,
        backgroundColor: '#F3F5FC',
        borderWidth: 2,
        borderColor: '#E4E7EC',
        borderRadius: 2,
        justifyContent: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        flex: 1
    },
    imageContainer: {
        flex: 1,
    },
    imageContainerMobile: {
        width: '100%',
        padding: 24,
        backgroundColor: '#F3F5FC',
        borderWidth: 1,
        borderColor: '#E4E7EC',
        borderRadius: 2,
        justifyContent: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        alignItems: 'center',
        marginBottom: 12
    },
    downloadFormBottomContainer: {
        flexDirection: 'row',
        paddingVertical: 12,
        width: '100%',
        position: 'absolute',
        bottom: 0,
        height: 60,
        alignContent: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        backgroundColor: 'white'
    },
    downloadFormBottomContainerAppView: {
        borderTopWidth: 1,
        borderColor: '#F2F4F7',
        flex: 0.5
    },
    downloadFormBottomContainerMobile: {
        flexDirection: 'row',
        padding: 16,
        width: '100%',
        position: 'absolute',
        bottom: 0,
        alignContent: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        borderTopWidth: 1,
        borderColor: '#F2F4F7'
    },
    button: {
        flex: 0.5
    },
});
// @ts-ignore
export default (PreviewCollateral);
